module.exports = __webpack_public_path__ + "img/wisdom_10.34747893.svg";